import { createSelector } from 'reselect'
import isAirecEnabledSelector from '../feature-scope/isAirecEnabledSelector'
import isVwnRecommendationsEnabledSelector from '../feature-scope/isVwnRecommendationsEnabledSelector'
import vwnRecommendationsForModelDataSelector from './vwnRecommendationsForModelDataSelector'
import aiRecommendationsForModelDataSelector from './aiRecommendationsForModelDataSelector'
import aiRecommendationsRequestIsPendingSelector from '../pending-request/aiRecommendationsRequestIsPendingSelector'

const recommendationsBlockIsVisibleSelector = createSelector(
    isAirecEnabledSelector,
    isVwnRecommendationsEnabledSelector,
    vwnRecommendationsForModelDataSelector,
    aiRecommendationsForModelDataSelector,
    aiRecommendationsRequestIsPendingSelector,
    (isAirecEnabled, isVwnRecommendationsEnabled, vwnData, aiData, aiRequestPending): boolean => {
        if (isAirecEnabled) {
            return aiRequestPending || Boolean(aiData?.recommendations?.length)
        }
        if (isVwnRecommendationsEnabled) {
            return Boolean(vwnData?.recommendations?.length)
        }
        return false
    },
)

export default recommendationsBlockIsVisibleSelector
